module.exports = __webpack_public_path__ + "img/dog-gesture.90d51eb7.png";